import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { FiltersRoutes } from "./filters.routes";
import { FilterFilterBarComponent } from "./filter-filter-bar/filter-filter-bar.component";
import { FilterListComponent } from "./filter-list/filter-list.component";
import { FilterFormComponent } from "./filter-form/filter-form.component";
import { FilterValueFormComponent } from "./filter-value-form/filter-value-form.component";
import { FilterService, FilterFormService, FilterFilterPipe } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    FiltersRoutes,
  ],
  declarations: [
    FilterFilterBarComponent,
    FilterListComponent,
    FilterFormComponent,
    FilterValueFormComponent,
    FilterFilterPipe,
  ],
  providers: [FilterService, FilterFormService],
})
export class FiltersModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/filters.module.ts